/** Match theme: @media (max-width: 1024px) for overlay sidebar. */
export const MOBILE_SIDEBAR_BREAKPOINT_PX = 1024;

export function isMobileSidebarViewport() {
  return (
    typeof window !== "undefined" &&
    window.innerWidth <= MOBILE_SIDEBAR_BREAKPOINT_PX
  );
}

/**
 * On desktop, keep the full sidebar with labels (same as mobile drawer UX).
 * Icon-only rail + white hover flyout is confusing and inconsistent.
 */
export function toggleBodySidebarClasses() {
  const body = document.body;
  const mobile = isMobileSidebarViewport();

  if (mobile) {
    const willOpen = !body.classList.contains("sidebar-enable");
    body.classList.toggle("sidebar-enable");
    if (willOpen) {
      body.classList.remove("vertical-collpsed");
    }
  } else {
    body.classList.remove("vertical-collpsed");
    body.classList.remove("sidebar-enable");
  }
}

/** Hide the overlay drawer on small viewports (e.g. before opening a modal over the page). */
export function closeMobileSidebarDrawer() {
  if (typeof document === "undefined") return;
  if (isMobileSidebarViewport()) {
    document.body.classList.remove("sidebar-enable");
  }
}
